import React from 'react';
import { fromUtcToLocalMoment } from '../utilities/DateHelpers';
import { MomentTimeFormat } from '../MomentTimeFormat';
import moment from 'moment';

// similar logic exists in Broker.cshtml
const JobResourceOverrideDetails = ({ override }) => {
    if (!override) {
        return null;
    }

    const isDefault = Boolean(override.isDefault);
    const isLocalTime = Boolean(override.isLocalTime);
    const details = [];

    if (override.startTime) {
        // If the time is already in local timezone, use it directly; otherwise convert from UTC
        const displayMoment = isLocalTime
            ? moment(override.startTime)
            : fromUtcToLocalMoment(override.startTime);

        details.push(
            `Start: ${displayMoment.format(MomentTimeFormat.AnteTwelveHour)}`
        );
    }

    if (override.arcGisOriginAddrLoc) {
        details.push(`Origin: ${override.arcGisOriginAddrLoc}`);
    }

    if (override.arcGisDestinationAddrLoc) {
        details.push(`Destination: ${override.arcGisDestinationAddrLoc}`);
    }

    if (override.roadName) {
        details.push(`Road: ${override.roadName}`);
    }

    if (!details.length) {
        return null;
    }

    const className = isDefault ? 'text-info small' : 'text-warning small';
    const title = isDefault ? 'Job start time' : 'Job resource override';

    return (
        <div className={className} title={title}>
            {details.join(' | ')}
        </div>
    );
};

export default JobResourceOverrideDetails;
